import { useContext, useCallback, useEffect, useMemo } from "react";

import dayjs from "dayjs";

import { 
    QuotationInfoContext, 
    QuotationStep, 
    GenericDataFormContext, 
    LOADING_SAVED_QUOTATIONS_STATES, 
    LoadSavedQuotationsCard 
} from "../../../shared";

import { WizardDataFormContext } from "../../Wizard/contexts/WizardDataForm";
import { Activity } from "../../../../../../../shared/interfaces";

export const LoadSavedAPQuotations = () => {
    const { 
        setLoadingSavedQuotation, 
        setCurrentStep,
        savedQuotation,
        setLoadSaveQuotationState,
        loadSaveQuotationState,
    } = useContext(QuotationInfoContext);

    const { setPlansSelected } = useContext(GenericDataFormContext);
 
    const { setQuotationForm } = useContext(WizardDataFormContext);

    const filledCommonStates = useCallback(() => {
        setLoadSaveQuotationState(LOADING_SAVED_QUOTATIONS_STATES.INIT_LOADING);
        
        const { 
            numero, 
            cliente, 
            planSeleccionado, 
            arse, 
            formaDePago,
            vigenciaDesde,
            vigenciaHasta,
            rama,
            actividades,
        } = savedQuotation!;

        setPlansSelected([String(planSeleccionado)]);

        const formattedActivities: Array<Activity> = actividades.map(
            ({ codigo, parentesco, rangoDeEdad, cantidad, coberturasSeleccionadas, categoria, secuencia }: any) => ({
                codigo,
                cantidad,
                parentesco,
                secuencia,
                categoria,
                rangoDeEdad,
                cantidadDeCoberturas: String(coberturasSeleccionadas.length),
                coberturas: coberturasSeleccionadas.map(({ codigo, codigoRiesgo, sumaAsegurada, prima }: any) => ({
                    cobertura: codigo,
                    riesgo: codigoRiesgo,
                    sumaAsegurada: String(sumaAsegurada),
                    prima: String(prima),
                    pormilaje: '0'
                }))
            })
        );

        setQuotationForm({
            token: numero,
            articuloRamaSecuencia: arse,
            cliente: {
                nroAsegurado: cliente.nroAsegurado,
                tipoDocumento: cliente.tipoDeDocumento,
                nroDocumento: cliente.numeroDeDocumento,
                nombre: cliente.nombreCompleto,
                cuit: cliente.cuit,
                tipoPersona: cliente.tipoDePersona,
                codProvincia: cliente.provincia,
                codProvinciaInder: cliente.codProvinciaInder,
                codigoPostal: cliente.codigoPostal,
                sufijoCodigoPostal: cliente.sufijoCodigoPostal,
                condicionIVA: cliente.codigoCondicionIva
            },
            planDePago: `${formaDePago.codigoDePlanDePagos}`,
            vigenciaDesde: dayjs(vigenciaDesde, 'DD-MM-YYYY').format('YYYYMMDD'),
            vigenciaHasta: dayjs(vigenciaHasta, 'DD-MM-YYYY').format('YYYYMMDD'),
            plan: planSeleccionado,
            rama,
            porcentajeExtraPrimaVariable: formaDePago.porcentajeExtraPrimaVariable,
            actividades: formattedActivities,
            cantidadActividades: String(formattedActivities.length),
        });

    }, [
        savedQuotation,
        setPlansSelected,
        setQuotationForm,
        setLoadSaveQuotationState,
    ]);

    const allStepsAreFilled: boolean = useMemo(() => 
        loadSaveQuotationState === LOADING_SAVED_QUOTATIONS_STATES.STEP_THREE_DATA_FILLED,
        [loadSaveQuotationState]
    );

    const finishLoadingSaveQuotation = useCallback(() => {
        setLoadingSavedQuotation(false);
        setCurrentStep(QuotationStep.THREE);
    }, [
        setLoadingSavedQuotation,
        setCurrentStep,
    ]);

    useEffect(() => {
        if(allStepsAreFilled) {
            finishLoadingSaveQuotation()
        }
    }, [allStepsAreFilled]);
  
    useEffect(() => {
        filledCommonStates();
    }, []);
  
    return <LoadSavedQuotationsCard />;
};